<template>
  <van-popup
    v-model="show"
    round
    :close-on-popstate="false"
    position="bottom"
    closeable
    @close="close"
    :safe-area-inset-bottom="true"
  >
    <div class="return-account-popup">
      <div class="title">线下退款</div>


      <!-- 线下退款  -->
      <div class="more-account-wrapper">
        <van-cell center class="more-account-item" :border="false">
          <template #title>
            线下退款
          </template>
          <div class="money">¥{{ oweMoney }}元</div>
        </van-cell>
        <van-field
          v-if="hasCustom"
          :value="paymentRecordDetailName"
          label="退款账户"
          is-link
          required
          readonly
          placeholder="请选择"
          input-align="right"
          :border="false"
          @click="openAccounts"
        />
      </div>

      <van-field
        label="退费日期："
        :is-link="app.permission.op('refund_edit_time')"
        readonly
        placeholder="请选择"
        input-align="right"
        :border="false"
        @click="chooseChargeDate"
      >
        <template #input>
          <div style="color: var(--g8)">
            {{ chargeDate }}
          </div>
        </template>
      </van-field>     
      <page-footer-btn multipleBtns>
        <van-button
          square
          round
          block
          type="primary"
          @click="dosomething"
        >
          <template> 确认退款：{{ oweMoney }} </template>
        </van-button>
      </page-footer-btn>
    </div>
    <custom-account ref="customAccount"></custom-account>
  </van-popup>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
import customAccount from '@teacher/views/sf/popup/custom-account-popup.vue';

export default {
  name: 'return-account-popup',
  props: {
    flag: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      show: false,
      cdate: '',
      paymentRecordDetailList: [],
      oweMoney: 0,
      orderId: null,
      campusId: '',
      hasCustom: false,
    };
  },
  components: {
    pageFooterBtn,
    customAccount,
  },
  computed: {
    paymentRecordDetailName() {
      return this.paymentRecordDetailList
        .filter(item => item.checked)
        .map(item => item.name)
        .join('，');
    },
    // 收费日期
    chargeDate() {
      return app.tool.date.formatDatetime(this.cdate, 'yyyy-MM-dd');
    },
  },
  methods: {
    async getPayAccountList() {
      if (this._isGeted) {
        return;
      }
      let ret = await this.$api.getPaymentAccountList({ comeFrom: 2 });
      if (ret.code === 200) {
        this.hasCustom = ret.data.hasCustom;
        this._isGeted = true;
      }
    },
    async openAccounts() {
      let ret = await this.$api.getPaymentAccountList({ comeFrom: 2, campusId: this.campusId });
      this.paymentRecordDetailList = ret.data.offlineCustomAccount.map(item => {
        return {
          name: item.name,
          paymentAccountCustomId: item.id,
          money: '',
          checked: false,
        };
      });
      this.$refs.customAccount
        .open({
          type: 'tf',
          paymentRecordDetailList: this.paymentRecordDetailList,
          oweMoney: this.oweMoney,
        })
        .then(({ paymentRecordDetailList }) => {
          this.$refs.customAccount.show = false;
          this.paymentRecordDetailList = paymentRecordDetailList;
        });
    },
    dosomething() {
      // 检查
      if (this.oweMoney == 0) {
        vant.Toast('线下退款金额不能为0');
        return;
      } else if (
        this.hasCustom &&
        this.paymentRecordDetailList.filter(item => item.checked).length == 0 &&
        this.oweMoney > 0
      ) {
        vant.Toast('请选择退款账户');
        return;
      } else if (!this.cdate) {
        vant.Toast('请选择退费日期');
        return;
      }

      const obj = {
        cdate: this.cdate && this.cdate.getTime(),
        paymentRecordDetailList: this.paymentRecordDetailList,
      };
      this._rsv && this._rsv(obj);
    },
    open({ cdate, oweMoney, orderId, campusId }) {
      this.show = true;
      this.cdate = new Date(cdate);

      this.oweMoney = +oweMoney;
      this.orderId = orderId;
      this.campusId = campusId;

      // 清理
      this.paymentRecordDetailList = [];


      return new Promise((rsv, rej) => {
        this._rsv = rsv;
        this._rej = rej;
      });
    },
    close() {
      this._rej && this._rej();
    },
    async chooseChargeDate() {
      if (app.permission.op('refund_edit_time')) {
        let res = await app.x3.picker.calendar({
          defaultDate: this.cdate,
          minDate: new Date(2020, 1, 1),
          maxDate: new Date(),
        });
        this.cdate = res;
      }
    },
  },
  created() {
    this.getPayAccountList();
  },
};
</script>

<style lang="scss" scoped>
.return-account-popup {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}

.money {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--g8);
  font-weight: var(--bold);
}
.title {
  height: 44px;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--g8);
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
}
.more-account-wrapper {
  overflow: auto;
  flex: 1 1 auto;
  .more-account-item {
    padding: 6px 16px;
    height: 44px;
    ::v-deep .input {
      border: 1px solid var(--g3);
      padding: 5px 12px;
      border-radius: 8px;
    }
    ::v-deep .van-cell__value {
      flex: 0 0 auto;
    }
    ::v-deep input {
      width: 96px;
    }
  }
}

.info {
  flex: 0 0 auto;
  background: var(--g1);
  display: flex;
  justify-content: space-between;
  padding: 16px 16px;
  .left {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    color: var(--g6);
    .btn {
      color: var(--c1);
    }
  }
  .right {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g8);
    text-align: right;
    .money {
      font-weight: bold;
      margin-left: 5px;
    }
    .red {
      color: var(--c3);
    }
    .warn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>